import { cellForced, SELECT_CONFIG } from '../config'
import { parseString } from '../util'

let _getRowKey = rowKey => {
  let keyFn = rowKey
  if (typeof rowKey !== 'function') {
    keyFn = record => parseString(rowKey, record)
  }
  return function (record, index) {
    let key = keyFn(record)
    return key === undefined || key === '' ? index : key
  }
}

function getKeysMap (data = [], getRowKeyFn) {
  const obj = {}
  data.forEach((item, i) => {
    obj[getRowKeyFn(item, i)] = item
  })
  return obj
}

export default {
  data () {
    return {
      defaultSelection: {},
      selectionMap: {}
      // isAllSelected: false,
      // computedGetRowKey: _getRowKey(this.groupRowKey || 'id')
    }
  },
  computed: {
    computedGetRowKey () {
      return _getRowKey(this.groupRowKey)
    },
    isAllSelected () {
      if (this.isAllDisabled) return false
      if ( this.defaultSelection.selectedRows.length < this.dataSource.length ) {
        return false
      }
      return this.dataSource.every((row, index) => this.selectionMap[this.computedGetRowKey(row, index)])
    },
    isAllDisabled () {
      return (
        this.dataSource.length === 0 ||
        this.dataSource.every(
          (row, index) => !this.isRowSelectable(row, index)
        )
      )
    },
    indeterminate () {
      return this.defaultSelection.selectedRows.length > 0 && !this.isAllSelected
    },
    radioSelect () {
      return this.defaultSelection.selectedRows[0]
    },
    reserveSelection () {
      return this.selectColumn?.reserveSelection
    }
  },
  methods: {
    // 初始化
    init () {
      const { defaultSelection } = this
      if (
        !defaultSelection.selectedRows ||
        !Array.isArray(defaultSelection.selectedRows)
      ) {
        defaultSelection.selectedRows = []
      }

      this.CONFIG = {
        checkbox: {
          toggleRowSelectionFn: this.togglerowBoxSelected,
          renderCell: cellForced.selection.renderCheckboxCell.bind(this)
          // valueFn: this.getRowSelectState
        },
        radio: {
          renderCell: cellForced.selection.renderRadioCell.bind(this),
          toggleRowSelectionFn: this.toggleRadiorowSelected.bind(this),
          valueFn: this.computedGetRowKey
        }
      }
    },

    // 当前行是否可以勾选
    isRowSelectable (row, index) {
      const selectable = this.selectColumn?.selectable
      return selectable ? selectable(row, index) : true
    },

    // // 当前行选中状态
    // getRowSelectState (row, index) {
    //   return this.defaultSelection.selectedRows.includes(this.getRowKey(row, index))
    // },

    // 全选
    toggleAllSelection () {
      const { defaultSelection, isAllSelected, indeterminate, reserveSelection, selectionMap } = this
      reserveSelection ? this.cleanSelection(true) : this.clearSelection()
      if (!isAllSelected && (!indeterminate || reserveSelection)) {
        this.dataSource.forEach((row, index) => {
          if (!this.isRowSelectable(row, index)) return
          let key = this.computedGetRowKey(row, index)
          defaultSelection.selectedRows.push(key)
          this.$set(selectionMap, key, row)
        })
      }
      this._selectChange()
    },

    // 多选模式切换行选中状态
    togglerowBoxSelected (row, rowIndex, selectState) {
      if (!row) {
        console.log('当前项row不存在')
        return
      }
      const { defaultSelection } = this
      const curRowKey = this.computedGetRowKey(row, rowIndex)
      const index = defaultSelection.selectedRows.indexOf(curRowKey)
      // 如果设置了当前状态 则不处理
      if (
        (selectState === true && index !== -1) ||
        (selectState === false && index === -1)
      ) {
        return
      }
      index === -1
        ? defaultSelection.selectedRows.push(curRowKey)
        : defaultSelection.selectedRows.splice(index, 1)
      this.cacheSelectionMap(row, curRowKey, index === -1)
      this._selectChange()
    },

    // 存储
    cacheSelectionMap (row, curRowKey, isAdd) {
      const { selectionMap } = this
      if (isAdd) {
        this.$set(selectionMap, curRowKey, row)
      } else {
        this.$delete(selectionMap, curRowKey)
      }
    },

    // 单选
    toggleRadiorowSelected (row, rowIndex) {
      const { defaultSelection, selectionMap } = this
      const curRowKey = this.computedGetRowKey(row, rowIndex)
      defaultSelection.selectedRows.splice(0, 1, curRowKey)
      this.$set(selectionMap, curRowKey, row)
      this._selectChange()
    },

    // 调用外部筛选
    _selectChange () {
      const {
        selectionMap,
        defaultSelection: { selectedRows, selectionChange }
      } = this
      const selectArr = selectedRows.map(key => selectionMap[key])
      selectionChange && selectionChange(selectArr, selectedRows)
    },

    // 渲染
    

    // 更新默认值
    update (val) {
      if (this.defaultSelection.selectedRows !== val.selectedRows) {
        this.defaultSelection.selectedRows = val.selectedRows || []
      }
    },


    // 更新选中状态
    updateSelect (dataInstanceChanged) {
      const { selectColumn, groupRowKey } = this
      if (selectColumn?.reserveSelection) {
        if (!groupRowKey) throw new Error('[ElTable] prop row-key is required')
      } else {
        dataInstanceChanged ? this.clearSelection() : this.cleanSelection()
      }
    },

    // 清空
    clearSelection () {
      const { defaultSelection } = this
      if (defaultSelection.selectedRows.length > 0) {
        defaultSelection.selectedRows.splice(0, defaultSelection.selectedRows.length)
      }
    },
      // 渲染
    renderRowSelection (columns, selectColumn) {
      const { defaultSelection } = this
      let selectionColumn = Object.assign(
        {},
        SELECT_CONFIG,
        defaultSelection,
        selectColumn
      )
      const { toggleRowSelectionFn } = this.CONFIG[selectionColumn.selectType]
      this.selectColumn = selectionColumn
      this.toggleRowSelectionFn = toggleRowSelectionFn
      selectionColumn.title = () => {
        return (<el-checkbox
          disabled={this.isAllDisabled}
          indeterminate={this.indeterminate}
          on-input={this.toggleAllSelection}
          v-model={this.isAllSelected}
          nativeOn-click={event => event.stopPropagation()}
        />)
      }

      selectionColumn.customRender = ({ row, $index: rowIndex }) => {
        const curRowKey = this.computedGetRowKey(row, rowIndex)
        return <div style='min-width: 55px;text-align: center'><el-checkbox
          value={!!this.selectionMap[curRowKey]}
          disabled={selectionColumn.selectable
            ? !selectionColumn.selectable(row, rowIndex)
            : false}
          nativeOn-click={event => event.stopPropagation()}
          on-input={() => {
            toggleRowSelectionFn(row, rowIndex)
          }}
        /></div>
      }
      // // 当前不是单选
      if (
        columns.some(column => column.fixed === 'left' || column.fixed === true)
      ) {
        selectionColumn.fixed = 'left'
      }
      columns.unshift(selectionColumn)
      this.defaultSelection.selectionChange = selectionColumn.selectionChange
      return columns
    },

    // 局部更新
    cleanSelection (flag = false) {
      const { defaultSelection, dataSource, selectionMap } = this
      if (defaultSelection.selectedRows.length > 0) {
        const dataMap = getKeysMap(dataSource, this.computedGetRowKey)
        for (let i = 0; i < defaultSelection.selectedRows.length; i++) {
          let key = defaultSelection.selectedRows[i]
          if (flag ? dataMap[key] : !dataMap[key]) {
            defaultSelection.selectedRows.splice(i, 1)
            this.$delete(selectionMap, key)
            i--
          }
        }
        this._selectChange()
      }
    },

    // 重置
    resetSelection () {
      const {
        defaultSelection: { selectionChange }
      } = this
      this.clearSelection()
      this.selectionMap = {}
      selectionChange && selectionChange([])
    },
        // 切换选中状态 对外
    toggleRowSelection ({ rows, state: selectState }) {
      if (Array.isArray(rows)) {
        rows.forEach((row, index) => {
          this.toggleRowSelectionFn(row, index, selectState)
        })
      } else {
        this.toggleRowSelectionFn(rows, null, selectState)
      }
    }
  }
}